import * as React from "react";
import { routes } from "configs";

const TeacherSectionAssignments = React.lazy(
  () => import("./teacher/teacher-section-assignments"),
);

const AssessmentPackage = React.lazy(
  () => import("./teacher/search-tool/assessment-package"),
);
const ScopeElement = React.lazy(
  () => import("./teacher/search-tool/scope-element"),
);
const SearchToolScopes = React.lazy(
  () => import("./teacher/search-tool/scopes"),
);
const SearchToolAssessmentPackages = React.lazy(
  () => import("./teacher/search-tool/assessment-packages"),
);
const StudentAssignment = React.lazy(() => import("./student/assignment"));
const AssignmentReview = React.lazy(
  () => import("./teacher/assignment/review"),
);
const AssignmentPreview = React.lazy(
  () => import("./teacher/assignment/preview"),
);
const Scope = React.lazy(() => import("./teacher/search-tool/scope"));

export default [
  {
    path: routes.lti.schoology.teacherSectionAssignments,
    key: routes.lti.schoology.teacherSectionAssignments,
    component: TeacherSectionAssignments,
    exact: true,
  },
  {
    path: routes.lti.schoology.searchToolScopes,
    key: routes.lti.schoology.searchToolScopes,
    component: SearchToolScopes,
    exact: true,
  },
  {
    path: routes.lti.schoology.searchToolAssessmentPackages,
    key: routes.lti.schoology.searchToolAssessmentPackages,
    component: SearchToolAssessmentPackages,
    exact: true,
  },
  {
    path: routes.lti.schoology.searchToolScope,
    key: routes.lti.schoology.searchToolScope,
    component: Scope,
    exact: true,
  },
  {
    path: routes.lti.schoology.searchToolElement,
    key: routes.lti.schoology.searchToolElement,
    component: ScopeElement,
    exact: true,
  },
  {
    path: routes.lti.schoology.searchToolAssessmentPackage,
    key: routes.lti.schoology.searchToolAssessmentPackage,
    component: AssessmentPackage,
    exact: true,
  },
  {
    path: routes.lti.schoology.studentAssignment,
    key: routes.lti.schoology.studentAssignment,
    component: StudentAssignment,
    exact: true,
  },
  {
    path: routes.lti.schoology.review,
    key: routes.lti.schoology.review,
    component: AssignmentReview,
    exact: true,
  },
  {
    path: routes.lti.schoology.preview,
    key: routes.lti.schoology.preview,
    component: AssignmentPreview,
    exact: true,
  },
];
